let sessionId = crypto.randomUUID();

/**
 * Returns the current session-scoped ID. Stable within a logged-in user's
 * session; rotated by rotateSessionId() on logout so the next user on a
 * shared device gets a fresh ID.
 *
 * Injected as `x-session-id` on every GraphQL request and as `session.id` on
 * Application Insights telemetry, creating a join key across systems.
 *
 * Trace context (`traceparent`, `tracestate`, `Request-Context`) is owned by
 * the Application Insights SDK — see initializeTelemetry() in telemetry.ts.
 */
export function getSessionId(): string {
  return sessionId;
}

/**
 * Mints a new session ID. Call on logout so authenticated requests from a
 * subsequent user (or unauthenticated browsing) don't collide with the
 * previous session in telemetry. App Insights user context is cleared
 * separately via clearUserContext().
 */
export function rotateSessionId(): string {
  sessionId = crypto.randomUUID();
  return sessionId;
}
